import React, { useEffect, useState } from 'react'
import '../Settings/posSettings.css'
import { Autocomplete, IconButton, TextField, Tooltip } from '@mui/material'
import { useSelector } from 'react-redux'
import { chartOfAccountListApiCall } from '../../../../../API/AccountUpdated/chartOfAccountAPI'
import { journalListApiCall } from '../../../../../API/AccountUpdated/journalAPI'
import { postPosSettingsAPICall, viewPosSettingsAPICall } from './posSettingsAPI'
import SuccessSnackbar from '../../../../Single Components/SnackBars/SuccessSnackbar'
import ErrorSnackbar from '../../../../Single Components/SnackBars/ErrorSnackbar'
import { findObjFromList } from '../../../../../Js/generalFunctions'
export const PosSettings = () => {
  const chartOfAccountList = useSelector((state) => state.chartOfAccountsSlice.value)
  const journalList = useSelector((state) => state.journalSlice.value)
  const posSettingsList = useSelector((state) => state.posSettingSlice.apiResList);
  const decimalPosition = localStorage.getItem('decimalPosition')

  const receivableList = chartOfAccountList?.filter(item => item.type === "Receivables");
  const incomeAccList = chartOfAccountList?.filter(item => item.type === "Income");
  const expenseAccList = chartOfAccountList?.filter(item => item.type === "Cost of revenue");
  const expenseRoundAccList = chartOfAccountList?.filter(
    (item) => item.type === "Expenses"
  );
  const bankAndCashAccList = chartOfAccountList?.filter(item => item.type === "Bank and cash");
  const typeCashAndBankJournalList = journalList?.filter(item => item.type === "cash")
  const typesalesInJournalList = journalList?.filter(item => item.type === 'sales')


  const [snackBarStates, setSnackBarStates] = useState({
    success: false,
    error: false,
    message: "",
  })
  const [validationAlert, setValidationAlert] = useState({})
  const [formValues, setFormValues] = useState({
    posAccounts: false,
    posReceivable: null,
    posIncome: null,
    posDiscount: null,
    posBankCharges: null,
    cashGainOrLoss: null,
    deliveryChargeAccount: null,
    posJournal: null,
    packagingChargeAccount: null,

    pettyCash: false,
    pettyCashJournal: null,

    cashInOrOut: false,
    cashInOrOutAccount: null,

    activeWallet: false,
    walletjournal: null,

    activeLoyalty: false,
    loyaltyJournal: null,
    negativeStock: false,

    enableRoundOff: false,
    roundOffAccount: null,
     onlyCustomer:false,
     billingTheme: 'classic', // classic or premium
     billingPaymentTypeView: 'list', // list or card
     billingItemCardView: 'filled', // filled or center
     billingItemCardSize: 'large', // large, medium, small
  })
  const closeSnackbar = () => {
    setSnackBarStates({
      ...snackBarStates, success: false,
      error: false,
      message: "",
    })
  }
  const getFormInfo = (key) => (e, newValue) => {

    setFormValues({ ...formValues, [key]: newValue !== undefined ? newValue : e.target.value })
  }
  const checkboxChange = (key) => (e) => {
    setFormValues({ ...formValues, [key]: e.target.checked })
  }

  const roundValues = () => {
    setFormValues({ ...formValues, deliveryAmt: Number(formValues.deliveryAmt)?.toFixed(decimalPosition), packageAmt: Number(formValues.packageAmt)?.toFixed(decimalPosition) })
  }
  const payload = {
    posStatus: formValues?.posAccounts,
    posAccounts: formValues?.posAccounts === false ? null : {
      posReceivableAccount: formValues?.posReceivable?._id,
      posIncomeAccount: formValues?.posIncome?._id,
      posDiscountAccount: formValues?.posDiscount?._id,
      posBankChargesAccount: formValues?.posBankCharges?._id,
      // cashGainOrLossAccount:formValues?.cashGainOrLoss?._id,
      deliveryChargeAccount: formValues?.deliveryChargeAccount?._id,
      packagingChargeAccount: formValues?.packagingChargeAccount?._id,
      posJournalAccount: formValues?.posJournal?._id


    },
    cashInOutStatus: formValues?.cashInOrOut,
    cashInOut: {
      cashInOutAccount: formValues?.cashInOrOut === true ? formValues?.cashInOrOutAccount?._id : null
    },
    pettyCashStatus: formValues?.pettyCash,
    pettyCash: {
      PettycashJournel: formValues?.pettyCash === true ? formValues?.pettyCashJournal?._id : null
    },
    activeWalletStatus: formValues?.activeWallet,
    activeWallet: {
      activeWalletJournel: formValues?.activeWallet === true ? formValues?.walletjournal?._id : null
    },
    activeLoyaltyStatus: formValues?.activeLoyalty,
    activeLoyalty: {
      activeLoyaltyJournel: formValues?.activeLoyalty === true ? formValues?.loyaltyJournal?._id : null
    },
    isNegativeStock: formValues?.negativeStock,
    enableRoundOff: formValues?.enableRoundOff,
    roundOffAccount: formValues?.enableRoundOff === true ? formValues?.roundOffAccount?._id : null,
    // roundOffAccount: {
    //   roundOffAccount:formValues?.enableRoundOff === true ? formValues?.roundOffAccount?._id : null,
    // }
    customerStatus:formValues?.onlyCustomer,
    billingTheme: formValues?.billingTheme,
    billingPaymentTypeView: formValues?.billingPaymentTypeView,
    billingItemCardView: formValues?.billingItemCardView,
    billingItemCardSize: formValues?.billingItemCardSize,
  }
  const saveBtnClick = () => {
    // Save theme to localStorage as fallback until backend is updated
    localStorage.setItem('billingTheme', formValues?.billingTheme || 'classic');
    localStorage.setItem('billingPaymentTypeView', formValues?.billingPaymentTypeView || 'list');
    localStorage.setItem('billingItemCardView', formValues?.billingItemCardView || 'filled');
    localStorage.setItem('billingItemCardSize', formValues?.billingItemCardSize || 'large');
    
    let message = "Select this field"
    if (formValues?.posAccounts === true && formValues?.posReceivable === null) {
      setValidationAlert({ ...validationAlert, receivableAcc: message })
    }
    else if (formValues?.posAccounts === true && formValues?.posIncome === null) {
      setValidationAlert({ ...validationAlert, posIncome: message })
    }
    else if (formValues?.posAccounts === true && formValues?.posDiscount === null) {
      setValidationAlert({ ...validationAlert, posDiscount: message })
    }
    else if (formValues?.posAccounts === true && formValues?.posBankCharges === null) {
      setValidationAlert({ ...validationAlert, posBankCharges: message })
    }
    // else if(formValues?.posAccounts===true && formValues?.cashGainOrLoss === null){
    //   setValidationAlert({...validationAlert,cashGainOrLoss:message})
    // }
    else if (formValues?.posAccounts === true && formValues?.deliveryChargeAccount === null) {
      setValidationAlert({ ...validationAlert, deliveryCharge: message })
    }



    else if (formValues?.posAccounts === true && formValues?.posJournal === null) {
      setValidationAlert({ ...validationAlert, posJournal: message })
    }
    else if (formValues?.posAccounts === true && formValues?.packagingChargeAccount === null) {
      setValidationAlert({ ...validationAlert, packagingChargeAccount: message })
    }




    else if (formValues?.pettyCash === true && formValues?.pettyCashJournal === null) {
      setValidationAlert({ ...validationAlert, pettyCashAccount: message })
    }
    else if (formValues?.cashInOrOut === true && formValues?.cashInOrOutAccount === null) {
      setValidationAlert({ ...validationAlert, cashInOrOutAccount: message })
    }
    else if (formValues?.activeWallet === true && formValues?.walletjournal === null) {
      setValidationAlert({ ...validationAlert, walletjournal: message })
    }
    else if (formValues?.activeLoyalty === true && formValues?.loyaltyJournal === null) {
      setValidationAlert({ ...validationAlert, loyaltyJournal: message })
    }
    else if (formValues?.enableRoundOff === true && formValues?.roundOffAccount === null) {
      setValidationAlert({ ...validationAlert, roundOffAccount: message })
    }
    else {
      postPosSettingsAPICall(payload, setSnackBarStates, snackBarStates)
    }


  }
  useEffect(() => {
    posSettingsList !== undefined &&
      setFormValues({
        ...formValues,
        posAccounts: posSettingsList?.posStatus,
        posReceivable: findObjFromList("_id", chartOfAccountList, "posReceivableAccount", posSettingsList?.posAccounts),
        posIncome: findObjFromList("_id", chartOfAccountList, "posIncomeAccount", posSettingsList?.posAccounts),
        posDiscount: findObjFromList("_id", chartOfAccountList, "posDiscountAccount", posSettingsList?.posAccounts),
        posBankCharges: findObjFromList("_id", chartOfAccountList, "posBankChargesAccount", posSettingsList?.posAccounts),
        cashGainOrLoss: findObjFromList("_id", chartOfAccountList, "cashGainOrLossAccount", posSettingsList?.posAccounts),
        deliveryChargeAccount: findObjFromList("_id", chartOfAccountList, "deliveryChargeAccount", posSettingsList?.posAccounts),
        packagingChargeAccount: findObjFromList("_id", chartOfAccountList, "packagingChargeAccount", posSettingsList?.posAccounts),

        posJournal: findObjFromList("_id", journalList, "posJournalAccount", posSettingsList?.posAccounts),

        pettyCash: posSettingsList?.pettyCashStatus,
        pettyCashJournal: findObjFromList("_id", journalList, "PettycashJournel", posSettingsList?.pettyCash),
        cashInOrOut: posSettingsList?.cashInOutStatus,
        cashInOrOutAccount: findObjFromList("_id", chartOfAccountList, "cashInOutAccount", posSettingsList?.cashInOut),
        activeWallet: posSettingsList?.activeWalletStatus,
        walletjournal: findObjFromList("_id", journalList, "activeWalletJournel", posSettingsList?.activeWallet),
        activeLoyalty: posSettingsList?.activeLoyaltyStatus,
        loyaltyJournal: findObjFromList("_id", journalList, "activeLoyaltyJournel", posSettingsList?.activeLoyalty),
        negativeStock: posSettingsList?.isNegativeStock,
        enableRoundOff: posSettingsList?.enableRoundOff,
        roundOffAccount: posSettingsList?.roundOffAccountName,
        // roundOffAccount: findObjFromList("_id", chartOfAccountList, "roundOffAccount", posSettingsList?.roundOffAccount),
         onlyCustomer:posSettingsList?.customerStatus,
         billingTheme: posSettingsList?.billingTheme || 'classic',
         billingPaymentTypeView: posSettingsList?.billingPaymentTypeView || localStorage.getItem('billingPaymentTypeView') || 'list',
         billingItemCardView: posSettingsList?.billingItemCardView || localStorage.getItem('billingItemCardView') || 'filled',
         billingItemCardSize: posSettingsList?.billingItemCardSize || localStorage.getItem('billingItemCardSize') || 'large',
      })
  }, [posSettingsList, chartOfAccountList, journalList])

  useEffect(() => {
    chartOfAccountListApiCall()
    journalListApiCall()
    viewPosSettingsAPICall()
  }, [])


  return (
    <div className="global-page-parent-container">
      <div className="global-white-bg-container" style={{ padding: "5px 8px" }}>
        <>
          <Tooltip title="Save">
            <IconButton
              onClick={saveBtnClick}
            >
              <i class="bi bi-floppy"></i>
            </IconButton>
          </Tooltip>
        </>
      </div>
      <div className="new-global-white-bg-container" style={{ height: "calc(100vh - 154px)", overflowY: "auto", margin: "6px 0" }}>

        <div className='checkbox-and-dropdown-container'>
          <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
          </div>
        </div>
        {/* 1 */}
        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="checkboxDropDown"
              value={formValues?.posAccounts}
              onChange={checkboxChange("posAccounts")}
              checked={formValues?.posAccounts === true}
            />
            <label htmlFor="checkboxDropDown">POS Accounts</label>
          </div>
          {
            formValues?.posAccounts === true &&

            <>
              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className="pos-settings-dropdown-container auto-complete-new">
                  <p>POS Receivable</p>
                  <Autocomplete
                    options={receivableList || []}
                    getOptionLabel={(option) => option?.accountName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.posReceivable}
                    onChange={getFormInfo("posReceivable")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.receivableAcc}</p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className='pos-settings-dropdown-container auto-complete-new'>
                  <p>POS Income</p>
                  <Autocomplete
                    options={incomeAccList || []}
                    getOptionLabel={(option) => option?.accountName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.posIncome}
                    onChange={getFormInfo("posIncome")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.posIncome}</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className='pos-settings-dropdown-container auto-complete-new'>
                  <p>POS Discount</p>
                  <Autocomplete
                    options={expenseAccList || []}
                    getOptionLabel={(option) => option?.accountName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.posDiscount}
                    onChange={getFormInfo("posDiscount")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.posDiscount}</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className='pos-settings-dropdown-container auto-complete-new'>
                  <p>POS Bank Charges</p>
                  <Autocomplete
                    options={expenseAccList || []}
                    getOptionLabel={(option) => option?.accountName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.posBankCharges}
                    onChange={getFormInfo("posBankCharges")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.posBankCharges}</p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className='pos-settings-dropdown-container auto-complete-new'>
                  <p>Delivery Charge</p>
                  <Autocomplete
                    options={incomeAccList || []}
                    getOptionLabel={(option) => option?.accountName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.deliveryChargeAccount}
                    onChange={getFormInfo("deliveryChargeAccount")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.deliveryCharge}</p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className='pos-settings-dropdown-container auto-complete-new'>
                  <p>Pos journal</p>
                  <Autocomplete
                    options={typesalesInJournalList || []}
                    getOptionLabel={(option) => option?.journalName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.posJournal}
                    onChange={getFormInfo("posJournal")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.posJournal}</p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
                <div className='pos-settings-dropdown-container auto-complete-new'>
                  <p>Packaging Charge</p>
                  <Autocomplete
                    options={incomeAccList || []}
                    getOptionLabel={(option) => option?.accountName}
                    renderInput={(params) => (<TextField {...params} />)}
                    value={formValues?.packagingChargeAccount}
                    onChange={getFormInfo("packagingChargeAccount")}

                  />

                </div>
                <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.packagingChargeAccount}</p>
              </div>
            </>
          }
        </div>
        {/* 2 */}
        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="PettyCash"
              value={formValues?.pettyCash}
              onChange={checkboxChange("pettyCash")}
              checked={formValues?.pettyCash === true}
            />
            <label htmlFor="PettyCash">Petty Cash</label>
          </div>
          {
            formValues?.pettyCash === true &&
            <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
              <div className='pos-settings-dropdown-container auto-complete-new'>
                <p>Petty Cash Journal</p>
                <Autocomplete
                  options={typeCashAndBankJournalList || []}
                  getOptionLabel={(option) => option?.journalName}
                  renderInput={(params) => (<TextField {...params} />)}
                  value={formValues?.pettyCashJournal}
                  onChange={getFormInfo("pettyCashJournal")}

                />

              </div>
              <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.pettyCashAccount}</p>
            </div>
          }


        </div>
        {/* 3 */}
        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="CashInOrOut"
              value={formValues?.cashInOrOut}
              onChange={checkboxChange("cashInOrOut")}
              checked={formValues?.cashInOrOut === true}
            />
            <label htmlFor="CashInOrOut">Cash In Or Out</label>
          </div>
          {
            formValues?.cashInOrOut === true &&
            <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
              <div className='pos-settings-dropdown-container auto-complete-new'>
                <p>Cash In Or Out Account</p>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={bankAndCashAccList || []}
                  getOptionLabel={(option) => option?.accountName}
                  renderInput={(params) => <TextField {...params}

                  />}

                  value={formValues?.cashInOrOutAccount}
                  onChange={getFormInfo("cashInOrOutAccount")}

                />

              </div>
              <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.cashInOrOutAccount}</p>
            </div>
          }


        </div>
        {/* 4 */}
        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="ActiveWallet"
              value={formValues?.activeWallet}
              onChange={checkboxChange("activeWallet")}
              checked={formValues?.activeWallet === true}
            />
            <label htmlFor="ActiveWallet">Active Wallet</label>
          </div>
          {
            formValues?.activeWallet === true &&
            <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
              <div className='pos-settings-dropdown-container auto-complete-new'>
                <p>Wallet Journal</p>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={typesalesInJournalList || []}
                  getOptionLabel={(option) => option?.journalName}
                  renderInput={(params) => <TextField {...params}
                  />}
                  value={formValues?.walletjournal}
                  onChange={getFormInfo("walletjournal")}


                />

              </div>
              <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.walletjournal}</p>
            </div>
          }



        </div>
        {/* 5 */}
        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="ActiveLoyalty"
              value={formValues?.activeLoyalty}
              onChange={checkboxChange("activeLoyalty")}
              checked={formValues?.activeLoyalty === true}
            />
            <label htmlFor="ActiveLoyalty">Active Loyalty</label>
          </div>
          {
            formValues?.activeLoyalty === true &&
            <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
              <div className='pos-settings-dropdown-container auto-complete-new'>
                <p>Loyalty Journal</p>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={typesalesInJournalList || []}
                  getOptionLabel={(option) => option?.journalName}
                  renderInput={(params) => <TextField {...params}

                  />}

                  value={formValues?.loyaltyJournal}
                  onChange={getFormInfo("loyaltyJournal")}

                />

              </div>
              <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.loyaltyJournal}</p>
            </div>
          }



        </div>
        {/* 6 */}
        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="negativeStock"
              value={formValues?.negativeStock}
              onChange={checkboxChange("negativeStock")}
              checked={formValues?.negativeStock === true}
            />
            <label htmlFor="negativeStock">Negative Stock</label>
          </div>
        </div>

        <div className='checkbox-and-dropdown-container'>
          <div className='pos-settings-checkbox-container'>
            <input
              type="checkbox"
              id="roundingAccount"
              value={formValues?.enableRoundOff}
              onChange={checkboxChange("enableRoundOff")}
              checked={formValues?.enableRoundOff === true}
            />
            <label htmlFor="roundingAccount">Round Off</label>
          </div>
          {
            formValues?.enableRoundOff === true &&
            <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
              <div className='pos-settings-dropdown-container auto-complete-new'>
                <p>Round Off Accounting</p>
                <Autocomplete
                  options={incomeAccList || []}
                  getOptionLabel={(option) => option?.accountName}
                  renderInput={(params) => (
                    <TextField {...params} placeHolder="select an account" />
                  )}
                  value={formValues.roundOffAccount}
                  onChange={getFormInfo("roundOffAccount")}
                />

              </div>
              <p style={{ margin: "0", color: "red", fontSize: "0.7rem", textAlign: "end" }}>{validationAlert?.roundOffAccount}</p>
            </div>
          }

        </div>

          <div className='checkbox-and-dropdown-container'>
            <div className='pos-settings-checkbox-container'>
              <input 
                type="checkbox" 
                id="onlyCustomer"
                value={formValues?.onlyCustomer}
                onChange={checkboxChange("onlyCustomer")}
                checked={formValues?.onlyCustomer===true}
                />
              <label htmlFor="onlyCustomer">Customer Mandatory</label>
            </div>

          </div>

          {/* Billing Theme Selection */}
          <div className='checkbox-and-dropdown-container' style={{ marginTop: '20px', borderTop: '2px solid #e2e8f0', paddingTop: '20px' }}>
            <div style={{ width: '100%' }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', fontSize: '16px', fontWeight: 600 }}>Billing Screen Theme</h4>
              <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                {/* Classic Theme */}
                <div 
                  onClick={() => setFormValues({...formValues, billingTheme: 'classic'})}
                  style={{
                    flex: '1',
                    minWidth: '280px',
                    maxWidth: '400px',
                    border: formValues?.billingTheme === 'classic' ? '3px solid #667eea' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: formValues?.billingTheme === 'classic' ? '#f7fafc' : 'white',
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '180px',
                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    <div style={{ textAlign: 'center', zIndex: 1 }}>
                      <i className="bi bi-grid-3x3-gap" style={{ fontSize: '48px', color: '#4a5568' }}></i>
                      <p style={{ margin: '8px 0 0 0', color: '#4a5568', fontSize: '14px' }}>Classic Layout</p>
                    </div>
                    {formValues?.billingTheme === 'classic' && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        background: '#667eea',
                        color: 'white',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check-lg" style={{ fontSize: '20px' }}></i>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#2d3748' }}>Classic Theme</h5>
                  <p style={{ margin: 0, fontSize: '13px', color: '#718096' }}>Traditional grid layout with familiar interface</p>
                </div>

                {/* Premium Theme */}
                <div 
                  onClick={() => setFormValues({...formValues, billingTheme: 'premium'})}
                  style={{
                    flex: '1',
                    minWidth: '280px',
                    maxWidth: '400px',
                    border: formValues?.billingTheme === 'premium' ? '3px solid #667eea' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: formValues?.billingTheme === 'premium' ? '#f7fafc' : 'white',
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '180px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    <div style={{ textAlign: 'center', zIndex: 1 }}>
                      <i className="bi bi-stars" style={{ fontSize: '48px', color: 'white' }}></i>
                      <p style={{ margin: '8px 0 0 0', color: 'white', fontSize: '14px' }}>Modern Design</p>
                    </div>
                    {formValues?.billingTheme === 'premium' && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        background: 'white',
                        color: '#667eea',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check-lg" style={{ fontSize: '20px' }}></i>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#2d3748' }}>
                    Premium Theme 
                    <span style={{ 
                      marginLeft: '8px', 
                      fontSize: '11px', 
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontWeight: 600
                    }}>READY</span>
                  </h5>
                  <p style={{ margin: 0, fontSize: '13px', color: '#718096' }}>Modern design under development - all features being added</p>
                </div>
              </div>
            </div>
          </div>

          {/* Billing Item Card View */}
          <div className='checkbox-and-dropdown-container' style={{ marginTop: '20px', borderTop: '2px solid #e2e8f0', paddingTop: '20px' }}>
            <div style={{ width: '100%' }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', fontSize: '16px', fontWeight: 600 }}>Billing Item Card View</h4>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <div
                  onClick={() => setFormValues({ ...formValues, billingItemCardView: 'filled' })}
                  style={{
                    flex: '1',
                    minWidth: '260px',
                    maxWidth: '360px',
                    border: formValues?.billingItemCardView === 'filled' ? '3px solid #667eea' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: formValues?.billingItemCardView === 'filled' ? '#f7fafc' : 'white',
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '110px',
                    background: '#ffffff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    position: 'relative',
                    marginBottom: '10px'
                  }}>
                    <div style={{ height: '48px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }} />
                    <div style={{ padding: '8px 10px' }}>
                      <div style={{ height: '12px', width: '70%', background: '#1f2937', borderRadius: '4px', opacity: 0.35, marginBottom: '6px' }} />
                      <div style={{ height: '10px', width: '40%', background: '#1f2937', borderRadius: '4px', opacity: 0.2 }} />
                    </div>
                    {formValues?.billingItemCardView === 'filled' && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        background: '#667eea',
                        color: 'white',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check-lg" style={{ fontSize: '18px' }}></i>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#2d3748' }}>Image Filled (Header)</h5>
                  <p style={{ margin: 0, fontSize: '13px', color: '#718096' }}>Image fills the top area of the card</p>
                </div>

                <div
                  onClick={() => setFormValues({ ...formValues, billingItemCardView: 'center' })}
                  style={{
                    flex: '1',
                    minWidth: '260px',
                    maxWidth: '360px',
                    border: formValues?.billingItemCardView === 'center' ? '3px solid #667eea' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: formValues?.billingItemCardView === 'center' ? '#f7fafc' : 'white',
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '110px',
                    background: '#ffffff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    position: 'relative',
                    marginBottom: '10px',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <div style={{
                      height: '58px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <div style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '10px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      }} />
                    </div>
                    <div style={{ padding: '8px 10px', marginTop: 'auto' }}>
                      <div style={{ height: '12px', width: '70%', background: '#1f2937', borderRadius: '4px', opacity: 0.35, marginBottom: '6px' }} />
                      <div style={{ height: '10px', width: '40%', background: '#1f2937', borderRadius: '4px', opacity: 0.2 }} />
                    </div>
                    {formValues?.billingItemCardView === 'center' && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        background: '#667eea',
                        color: 'white',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check-lg" style={{ fontSize: '18px' }}></i>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#2d3748' }}>Center Image</h5>
                  <p style={{ margin: 0, fontSize: '13px', color: '#718096' }}>Image stays centered like the old design</p>
                </div>
              </div>
            </div>
          </div>

          {/* Billing Item Card Size */}
          <div className='checkbox-and-dropdown-container' style={{ marginTop: '20px', borderTop: '2px solid #e2e8f0', paddingTop: '20px' }}>
            <div style={{ width: '100%' }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', fontSize: '16px', fontWeight: 600 }}>Billing Item Card Size</h4>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                {[
                  { key: 'large', label: 'Large' },
                  { key: 'medium', label: 'Medium' },
                  { key: 'small', label: 'Small' }
                ].map((opt) => (
                  <div
                    key={opt.key}
                    onClick={() => setFormValues({ ...formValues, billingItemCardSize: opt.key })}
                    style={{
                      minWidth: '140px',
                      padding: '10px 12px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      border: formValues?.billingItemCardSize === opt.key ? '2px solid #667eea' : '2px solid #e2e8f0',
                      background: formValues?.billingItemCardSize === opt.key ? '#f7fafc' : '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '10px'
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span style={{ fontWeight: 700, color: '#2d3748', fontSize: '14px' }}>{opt.label}</span>
                      <span style={{ color: '#718096', fontSize: '12px' }}>
                        {opt.key === 'large' ? 'Default size' : opt.key === 'medium' ? 'Slightly smaller' : 'Compact grid'}
                      </span>
                    </div>
                    {formValues?.billingItemCardSize === opt.key && (
                      <span style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        background: '#667eea',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check" style={{ fontSize: '16px' }}></i>
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Billing Payment Type View */}
          <div className='checkbox-and-dropdown-container' style={{ marginTop: '20px', borderTop: '2px solid #e2e8f0', paddingTop: '20px' }}>
            <div style={{ width: '100%' }}>
              <h4 style={{ margin: '0 0 16px 0', color: '#2d3748', fontSize: '16px', fontWeight: 600 }}>Billing Payment Type View</h4>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <div
                  onClick={() => setFormValues({ ...formValues, billingPaymentTypeView: 'list' })}
                  style={{
                    flex: '1',
                    minWidth: '260px',
                    maxWidth: '360px',
                    border: formValues?.billingPaymentTypeView === 'list' ? '3px solid #667eea' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: formValues?.billingPaymentTypeView === 'list' ? '#f7fafc' : 'white',
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '110px',
                    background: '#ffffff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    position: 'relative',
                    marginBottom: '10px',
                    padding: '10px'
                  }}>
                    {[1, 2, 3].map((n) => (
                      <div key={n} style={{
                        height: '18px',
                        background: '#e6e8e9',
                        borderRadius: '6px',
                        marginBottom: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 8px',
                        gap: '8px'
                      }}>
                        <div style={{ width: '14px', height: '14px', borderRadius: '4px', background: '#cbd5e0' }} />
                        <div style={{ width: '60%', height: '8px', borderRadius: '4px', background: '#cbd5e0' }} />
                      </div>
                    ))}
                    {formValues?.billingPaymentTypeView === 'list' && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        background: '#667eea',
                        color: 'white',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check-lg" style={{ fontSize: '18px' }}></i>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#2d3748' }}>List View</h5>
                  <p style={{ margin: 0, fontSize: '13px', color: '#718096' }}>Payment types shown as a list</p>
                </div>

                <div
                  onClick={() => setFormValues({ ...formValues, billingPaymentTypeView: 'card' })}
                  style={{
                    flex: '1',
                    minWidth: '260px',
                    maxWidth: '360px',
                    border: formValues?.billingPaymentTypeView === 'card' ? '3px solid #667eea' : '2px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    background: formValues?.billingPaymentTypeView === 'card' ? '#f7fafc' : 'white',
                  }}
                >
                  <div style={{
                    width: '100%',
                    height: '110px',
                    background: '#ffffff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    position: 'relative',
                    marginBottom: '10px',
                    padding: '10px',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '8px'
                  }}>
                    {[1, 2, 3, 4].map((n) => (
                      <div key={n} style={{
                        background: '#f3f4f6',
                        borderRadius: '8px',
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        padding: '6px 4px'
                      }}>
                        <div style={{ width: '18px', height: '18px', borderRadius: '6px', background: '#cbd5e0' }} />
                        <div style={{ width: '70%', height: '6px', borderRadius: '4px', background: '#cbd5e0' }} />
                      </div>
                    ))}
                    {formValues?.billingPaymentTypeView === 'card' && (
                      <div style={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                        background: '#667eea',
                        color: 'white',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="bi bi-check-lg" style={{ fontSize: '18px' }}></i>
                      </div>
                    )}
                  </div>
                  <h5 style={{ margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#2d3748' }}>Card View</h5>
                  <p style={{ margin: 0, fontSize: '13px', color: '#718096' }}>Payment types shown as cards</p>
                </div>
              </div>
            </div>
          </div>
      </div>

      <SuccessSnackbar open={snackBarStates.success} handleClose={closeSnackbar} message={snackBarStates.message} />
      <ErrorSnackbar open={snackBarStates.error} handleClose={closeSnackbar} message={snackBarStates.message} />
    </div>
  )
}

